export default {
    namespaced: true,
    state: {
        activeIndex: '/biddinglist',
        openedIndex: [],
        navs: [{
            id: '1',
            level: 1,
            name: 'menu_pageText.HOME',
            type: 'link',
            url: '/home',
            isExpanded: false,
            isSelected: true,
            isNewWindow: false
        }],
        menus: [{
            id: '1',
            level: 1,
            name: 'menu_pageText.TENDERINFO',
            type: 'title',
            isExpanded: false,
            isSelected: false,
            isNewWindow: false,
            subMenus: [{
                    id: '1-1',
                    level: 2,
                    name: 'menu_pageText.BIDDINGLIST',
                    type: 'link',
                    url: '/biddinglist',
                    isExpanded: false,
                    isSelected: false,
                    isNewWindow: false
                }
                // ,
                // {
                //     id: '1-2',
                //     level: 2,
                //     name: 'menu_pageText.BIDDEDLIST',
                //     type: 'link',
                //     url: '/biddedlist',
                //     isExpanded: false,
                //     isSelected: false,
                //     isNewWindow: false
                // }, {
                //     id: '1-3',
                //     level: 2,
                //     name: 'menu_pageText.NOBIDLIST',
                //     type: 'link',
                //     url: '/nobidlist',
                //     isExpanded: false,
                //     isSelected: false,
                //     isNewWindow: false
                // }
            ]
        }]
    },
    mutations: {
        setActiveIndex(state, activeIndex) {
            state.activeIndex = activeIndex;
        },
        setOpenedIndex(state, openedIndex) {
            state.openedIndex.length = 0;
            state.openedIndex.push(openedIndex);
        }
    },
    getters: {
        activeIndex: state => state.activeIndex,
        openedIndex: state => state.openedIndex,
        navs: state => state.navs,
        menus: state => state.menus,
    }
}